



















































import Vue from "vue";
import env from "@/utils/env";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import WatcherBadge from "@/components/WatcherBadge.vue";
import { WatcherBadgeModel } from "@/components/WatcherBadge.vue";
import { PatientListViewModel, Watcher } from "@/models";

import _auth from "@/utils/auth";

export const UnmappedCareAreaName = "Other";

export interface CareArea {
  name: string;
  isSelected: boolean;
  count: number;
}

@Component({
  components: { WatcherBadge }
})
export default class SelectPatientsRow extends Vue {
  @Prop() readonly patient!: PatientListViewModel;

  get hasWatchers() {
    return this.patient?.watchers?.length > 0;
  }

  get watchers() {
    const watchers = this.patient?.watchers ?? [];
    // No need to show the current user that they are a watcher
    return watchers.filter((w: Watcher) => w.id !== _auth.user?.id);
  }

  get firstWatchersLimit() {
    const watchers = this.watchers;
    const results: WatcherBadgeModel[] = watchers.slice(0, env.watchersLimit);

    // If there are more watchers than the limit, remove the last watcher to show a badge
    // indicating the number of remaining watchers that couldn't be shown on the screen
    if (watchers.length > env.watchersLimit) {
      results.pop();
      const remaining = (watchers.length - env.watchersLimit) + 1;
      results.push({ label: `+${remaining}` });
    }

    return results;
  }

  get rowOneWatchers() {
    if (!this.hasWatchers) return [];

    const watchers = this.firstWatchersLimit;
    const length = Math.ceil(watchers.length / 2.0);
    return watchers.slice(0, length);
  }

  get rowTwoWatchers() {
    if (!this.hasWatchers) return [];

    const watchers = this.firstWatchersLimit;
    const length = watchers.length;
    const start = Math.ceil(length / 2.0);
    return watchers.slice(start);
  }

  clickedWatchers() {
    this.$emit("clickedWatchers");
  }
}
